<template>
  <div
    @click="clickHandler"
    class="tw-flex-between-center tw-gap-2 tw-bg-white tw-text-primary tw-py-8 tw-px-4 tw-rounded-t"
  >
    <div class="tw-flex-between-center tw-gap-2 tw-text-4">
      <i :class="[icon]" :style="{ color }" />
      <div class="tw-font-semibold">{{ text }}</div>
    </div>

    <i class="rtl:tw-hidden airalo-icon-arrow-right tw-text-3" />
    <i class="ltr:tw-hidden airalo-icon-arrow-left tw-text-3" />
  </div>
</template>

<script>
  export default {
    name: 'sim_featured-top',
    props: {
      text: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        required: true,
      },
      icon: {
        icon: {
          type: String,
          default: 'airalo-icon-star',
          validator(value) {
            return ['airalo-icon-star', 'airalo-icon-fire'].includes(value)
          },
        },
      },
    },
    methods: {
      clickHandler(event) {
        if (this.$listeners?.click) {
          event.preventDefault()
          event.stopPropagation()

          this.$emit('click', event)
        }
      },
    },
  }
</script>
